import { isEmpty, pick } from 'lodash/fp';

import useLocation from '@skippay/core/hooks/useLocation';
import { createHref } from '@skippay/core/utils/routeUtils';

const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid', 'promo'];

const useRichLink = (pathname: string): string => {
	const {
		location: { query },
	} = useLocation();
	const queryParams = pick(utmParams, query);

	return createHref({
		pathname,
		query: {
			...(!isEmpty(queryParams) &&
				(!query?.promo
					? {
							prev: 'paid',
					  }
					: { promo: query.promo })),
			...(typeof query?.abt !== 'undefined' && { abt: null }),
		},
	});
};

export default useRichLink;
